module.exports = __webpack_public_path__ + "static/assets/f416425360e58a9a3014d140ee2646e2.gif";